<template>
  <div class="node-wrapper">
    <v-card class="tree-card" elevation="2" outlined @click="handleClick()" :color="isActive ? 'primary' : ''"
      :dark="isActive">
      <v-card-text class="pa-3 text-center">
        <div class="f-bold f-14">
          {{ node.displayLabel }}
        </div>
        <div>
          <span class="secondary--text">Created By:</span>
          <span class="f-bold f-12">{{ node.username }}</span>
        </div>
        <div>
          <span class="secondary--text">Created Date:</span>
          <span class="f-bold f-12">{{ formatDate(node.spawn_date) }}</span>
        </div>
      </v-card-text>
    </v-card>
    <ul v-if="node.children && node.children.length">
      <li v-for="child in node.children" :key="child.OrderId">
        <OrderTreeNode :node="child" @handleClick="$emit('handleClick', $event)" :currentSoId="currentSoId" />
      </li>
    </ul>
  </div>
</template>
<script>
import Utility from "../../shared/utility";
export default {
  name: "OrderTreeNode",
  props: {
    node: {
      type: Object,
      required: true
    },
    currentSoId: {
      type: [String, Number],
      required: false
    }
  },
  computed: {
    isActive() {
      return Number(this.currentSoId) === Number(this.node.OrderId)
    }
  },
  methods: {
    handleClick() {
      this.$emit("handleClick", this.node.OrderId)
    },
    formatDate(date) {
      if (!date) return "-"
      return Utility.displayDateFormat(date)
    },
  }
}
</script>
<style>
.node-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.node-wrapper>ul {
  position: relative;
  padding-top: 20px;
  padding-left: 0px;
  display: flex;
  justify-content: center;
}

.node-wrapper>ul::before {
  content: "";
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  height: 20px;
  border-left: 1px solid #999;
}

.node-wrapper>ul>li {
  position: relative;
  padding: 20px 15px 0 15px;
}

.node-wrapper>ul>li::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  border-top: 1px solid #999;
}

.node-wrapper>ul>li:first-child::before {
  left: 50%;
}

.node-wrapper>ul>li:last-child::before {
  right: 50%;
}

.node-wrapper>ul>li::after {
  content: "";
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  height: 22px;
  border-left: 1px solid #999;
}

.tree-card {
  cursor: pointer;
  min-width: 220px;
  transition: all 0.2s ease;
}

.tree-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transform: translateY(-2px);
}
</style>